class DashboardApi {
  async getProfessions(accessToken) {
    const urlProfessions = `${process.env.REACT_APP_API_URL}/api/dashboard/professions`;

    const resp = await fetch(urlProfessions, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getOverview(accessToken, year) {
    const urlOverview = `${process.env.REACT_APP_API_URL}/api/dashboard/overview`;
    const resp = await fetch(urlOverview, {
      method: 'POST',
      body: JSON.stringify(year),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getSalesRevenue(accessToken, groupBy = 'inscription') {
    const urlSalesRevenue = `${process.env.REACT_APP_API_URL}/api/dashboard/salesRevenue`;

    const resp = await fetch(urlSalesRevenue, {
      method: 'POST',
      body: JSON.stringify({ groupBy }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getInfos(accessToken, year, month) {
    const urlInfos = `${process.env.REACT_APP_API_URL}/api/dashboard/infos`;
    const values = {};
    values.year = year;
    values.month = month;
    const resp = await fetch(urlInfos, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });


    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCostBreakdown(finished, year, accessToken) {
    const urlInfos = `${process.env.REACT_APP_API_URL}/api/dashboard/costBreakdown`;
    const values = {};
    values.finished = finished;
    values.year = year;
    const resp = await fetch(urlInfos, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getStatus(accessToken) {
    const urlInfos = `${process.env.REACT_APP_API_URL}/api/dashboard/status`;

    const resp = await fetch(urlInfos, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getComments(dateSelected, accessToken) {
    const urlInfos = `${process.env.REACT_APP_API_URL}/api/dashboard/comments`;
    const values = {};
    values.dateSelected = dateSelected;

    const resp = await fetch(urlInfos, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }
  
  async getCommentsRelaunch(dateSelected, accessToken) {
    const urlInfos = `${process.env.REACT_APP_API_URL}/api/dashboard/relaunch/comments`;
    const values = {};
    values.dateSelected = dateSelected;

    const resp = await fetch(urlInfos, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getList(accessToken) {
    const urlInfos = `${process.env.REACT_APP_API_URL}/api/dashboard/list`;

    const resp = await fetch(urlInfos, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCommercialProgress(accessToken) {
    const urlInfos = `${process.env.REACT_APP_API_URL}/api/dashboard/commercialProgress`;

    const resp = await fetch(urlInfos, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getSessions(accessToken, endDate, formation, source, relance, profession, year, month, financeur, format) {
    const urlSessions = `${process.env.REACT_APP_API_URL}/api/dashboard/sessions`;
    const values = {};
    values.endDate = endDate;
    values.formation = formation;
    values.source = source;
    values.relance = relance;
    values.profession = profession;
    values.year = year;
    values.month = month;
    values.financeur = financeur;
    values.format = format;
    const resp = await fetch(urlSessions, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json.data;
  }

  async getSessionsSubscribed(accessToken, endDate, formation, source, relance, profession, year, month, financeur, format) {
    const urlSessions = `${process.env.REACT_APP_API_URL}/api/dashboard/sessions-subscribed`;
    const values = {};
    values.endDate = endDate;
    values.formation = formation;
    values.source = source;
    values.relance = relance;
    values.profession = profession;
    values.year = year;
    values.month = month;
    values.financeur = financeur;
    values.format = format;
    const resp = await fetch(urlSessions, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json.data;
  }

  async getSessionsStatus(accessToken, endDate, formation, source, relance, profession, format) {
    const urlSessions = `${process.env.REACT_APP_API_URL}/api/dashboard/sessions-status`;
    const values = {};
    values.endDate = endDate;
    values.formation = formation;
    values.source = source;
    values.relance = relance;
    values.profession = profession;
    values.format = format;
    const resp = await fetch(urlSessions, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json.data;
  }

  async getFinishedValidate(accessToken) {
    const urlProfessions = `${process.env.REACT_APP_API_URL}/api/dashboard/get-finished-validate`;

    const resp = await fetch(urlProfessions, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getAttribute(accessToken) {
    const urlProfessions = `${process.env.REACT_APP_API_URL}/api/dashboard/attribute`;

    const resp = await fetch(urlProfessions, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getSuperAdmin(formationId, sourceId, relanceId, profession, accessToken) {
    const urlProfessions = `${process.env.REACT_APP_API_URL}/api/dashboard/superAdmin`;
    const values = { formationId, sourceId, relanceId, profession };
    const resp = await fetch(urlProfessions, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return json.data;
  }

  async getSaveDayLearnerSession(accessToken) {
    const urlProfessions = `${process.env.REACT_APP_API_URL}/api/dashboard/saveDayLearnerSession`;

    const resp = await fetch(urlProfessions, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getDataProfession(accessToken) {
    const urlProfessions = `${process.env.REACT_APP_API_URL}/api/dashboard/dataProfession`;

    const resp = await fetch(urlProfessions, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getDataFormationAndProfession(accessToken) {
    const urlProfessions = `${process.env.REACT_APP_API_URL}/api/dashboard/dataFormationAndProfession`;

    const resp = await fetch(urlProfessions, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getSources(accessToken) {
    const urlSources = `${process.env.REACT_APP_API_URL}/api/dashboard/getSources`;

    const resp = await fetch(urlSources, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCustomersProgression(date, accessToken) {
    const urlSources = `${process.env.REACT_APP_API_URL}/api/dashboard/get-customers-progression`;
    const values = {};
    values.dateSelected = date;
    const resp = await fetch(urlSources, {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCustomersRealTimeProgression(accessToken) {
    const urlSources = `${process.env.REACT_APP_API_URL}/api/dashboard/get-customers-realtime-progression`;
    const resp = await fetch(urlSources, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async notifyIncommingSessions(accessToken) {
    const urlSources = `${process.env.REACT_APP_API_URL}/api/sessions/notifications/notify-incoming-sessions`;
    const resp = await fetch(urlSources, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getTodayInscriptions(accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/dashboard/today-inscriptions`;
    const resp = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getKpis(accessToken, year) {
    const url = `${process.env.REACT_APP_API_URL}/api/dashboard/kpis`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ year }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getTeam(accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/dashboard/team`;
    const resp = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getShortcuts(accessToken, year) {
    const url = `${process.env.REACT_APP_API_URL}/api/dashboard/shortcuts`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ year }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCommercialRevenue(accessToken, year, month) {
    const url = `${process.env.REACT_APP_API_URL}/api/dashboard/commercialRevenue`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ year, month }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }
}

export const dashboardApi = new DashboardApi();

